import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Textarea from 'react-textarea-autosize';
import { FaLocationArrow } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import { useEvieChatContext } from '../EvieChatProvider';
import { useCreateChatMessage } from '../hooks';

import './chat-input.scss';

const ChatInput = ({ updateUserMessage, isEmptyMessages }) => {
  const { t } = useTranslation();
  const { isAwaitingResponse, isAwaitingGreeting } = useEvieChatContext();

  const [newMessage, setNewMessage] = useState('');
  // Writing during the greeting wait would race the greeting worker: the
  // in-lock dormancy re-check sees her message as fresh activity and drops
  // the greeting entirely. The wait is bounded (30s cap), never a lockout.
  const isDisabled = !newMessage.trim() || isAwaitingResponse || isAwaitingGreeting;

  const { sendMessage } = useCreateChatMessage({ updateUserMessage, setNewMessage });

  const onMessageChanged = ({ target: { value } }) => {
    setNewMessage(value);
  };

  const onKeyDown = (keyEvent) => {
    if (keyEvent.key === 'Enter' && !keyEvent.shiftKey && !isDisabled) {
      keyEvent.preventDefault();
      sendMessage(keyEvent, newMessage);
    }
  };

  return (
    <form className="chat-input" onSubmit={(event) => sendMessage(event, newMessage)}>
      <Textarea
        placeholder={
          isEmptyMessages
            ? t('evieApp.assistant.chatInput.placeholderEmpty')
            : t('evieApp.assistant.chatInput.placeholderDefault')
        }
        value={newMessage}
        onChange={onMessageChanged}
        onKeyDown={onKeyDown}
        minRows={1}
        maxRows={3}
        disabled={isAwaitingGreeting}
      />
      <button type="submit" disabled={isDisabled}>
        <FaLocationArrow />
      </button>
    </form>
  );
};

ChatInput.propTypes = {
  updateUserMessage: PropTypes.func.isRequired,
  isEmptyMessages: PropTypes.bool.isRequired,
};

export default ChatInput;
